export function normalizeCurrencyCents(value: unknown) {
  const number = Number(value ?? 0);
  if (!Number.isFinite(number)) return 0;
  return Math.trunc(number);
}

export function moneyToCents(value: unknown) {
  const number = Number(value ?? 0);
  if (!Number.isFinite(number)) return 0;
  return Math.round(number * 100);
}

export function centsToMoney(cents: unknown) {
  return normalizeCurrencyCents(cents) / 100;
}

export function formatBrlFromCents(value: unknown) {
  const cents = normalizeCurrencyCents(value);
  const sign = cents < 0 ? "-" : "";
  const absoluteCents = Math.abs(cents);
  const reais = Math.floor(absoluteCents / 100);
  const centavos = String(absoluteCents % 100).padStart(2, "0");
  const inteiro = String(reais).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return `${sign}R$ ${inteiro},${centavos}`;
}

export function appendCurrencyDigit(currentCents: unknown, digit: string) {
  if (!/^\d$/.test(digit)) return Math.max(0, normalizeCurrencyCents(currentCents));

  const cents = Math.max(0, normalizeCurrencyCents(currentCents));
  return cents * 10 + Number(digit);
}

export function appendCurrencyDigits(currentCents: unknown, digits: string) {
  return digits.replace(/\D/g, "").split("").reduce((cents, digit) => appendCurrencyDigit(cents, digit), Math.max(0, normalizeCurrencyCents(currentCents)));
}

export function removeCurrencyDigit(currentCents: unknown) {
  return Math.floor(Math.max(0, normalizeCurrencyCents(currentCents)) / 10);
}

export function parseCurrencyTextToCents(value: string) {
  const digits = value.replace(/\D/g, "");
  return digits ? Number(digits) : 0;
}
